module.exports = __webpack_public_path__ + "img/Facebook.d77ae1f8.svg";